import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FunnelCard from "../components/FunnelCard";
import { motion ,AnimatePresence} from "framer-motion";
import { useInView } from "react-intersection-observer";
import CountUp from "react-countup";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

function Home() {
  // Auto change slide every 3 seconds
   const [current, setCurrent] = useState(0);
    const [index, setIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [animate, setAnimate] = useState(false);
   const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formType, setFormType] = useState(""); // stores which button opened the form

 const [loading, setLoading] = useState(false);
   const slides = [
    { text: "Review, Execute and Convert ABM Campaigns to Sales Leads" },
    { text: "Maximize ROI with Cost-Effective B2B Marketing Solutions" },
    { text: "Intent-Focused, Data-Driven Demand Generation for B2B Success" },
  ];
  
const handleContactChange = (e) => {
  const { name, value } = e.target;
  setContactForm((prev) => ({ ...prev, [name]: value }));
};
const openModal = () => {
  setShowModal(true);
  setTimeout(() => setAnimate(true), 10); // trigger fade-in animation
};
  // 🔹 Close modal
  const closeModal = () => {
    setAnimate(false);
    setTimeout(() => setShowModal(false), 300);
  };
const [contactForm, setContactForm] = useState({
  fullname: "",
  company: "",
  website: "",
  email: "",
  phone: "",
  message: "",
  formType:"",
});
const isBusinessEmail = (email) => {
  const freeDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "icloud.com",
    "mail.com",
    "live.com"
  ];
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;
  return !freeDomains.includes(domain);
};

const handleContactSubmit = async (e) => {
  e.preventDefault();
 setLoading(true); // show loading message
  const { fullname, company, website, email, phone, message} = contactForm;
  // Basic validation
  if (!fullname || !email || !message || !company || !phone || !website) {
    alert("Please fill all required fields.");
      setLoading(false); // show loading message

    return;
  }
if (!isBusinessEmail(email)) {
    alert("Please enter a business email, not Gmail/Yahoo/etc.");
      setLoading(false); // show loading message

    return;
  }
 

  try {
    try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
    const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

    });

    if (response.ok) {
       setShowSuccessModal(true);  // ✅ This triggers modal to open
       setLoading(false); // show loading message
 closeModal();
       setContactForm({
        fullname: "",
        company: "",
        website: "",
        email: "",
        phone: "",
        message: "",
      });
    } else {
      alert("Error sending message.");
    }
  } catch (err) {
    console.error(err);
    alert("Error sending message.");
  }
};
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.6,
      duration: 1,
      ease: "easeOut",
    },
  },
};

const itemVariants = (direction = "left") => {
  const distance = 80;
  const offset =
    direction === "left"
      ? { x: -distance }
      : direction === "right"
      ? { x: distance }
      : direction === "up"
      ? { y: -distance }
      : { y: distance };

  return {
    hidden: { opacity: 0, ...offset, scale: 0.95 },
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
      scale: 1,
      transition: {
        duration: 1.2,
        ease: [0.25, 0.1, 0.25, 1], // smooth cubic-bezier
      },
    },
  };
};

   useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [slides.length]);

  const currentSlide = slides[index] ?? { text: "" };

const { ref, inView } = useInView({
    triggerOnce: true, // Counter triggers only once
    threshold: 0.3,    // 30% of div visible to start
  });

  
  const length = slides.length;

const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };
  const videos = [
    {
      src: "../images/tofuv.mp4",
      title: "TOFU",
    },
    {
      src: "../images/mofuv.mp4",
      title: "MOFU",
    },
    {
      src: "../images/bofuv.mp4",
      title: "BOFU",
    },
  ];

  // Brand logos slider
  const logos = ["1","2","3","4","5","6","7","8","9","10"];
  const brandSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    nextArrow: <div className="absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer text-black text-2xl">&#8250;</div>,
    prevArrow: <div className="absolute left-2 top-1/2 -translate-y-1/2 cursor-pointer text-black text-2xl">&#8249;</div>,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
  };
  return (
    
    <div>
     
      <Header />
      
       <main>
           <AnimatePresence>
          {showSuccessModal && (
            <motion.div
              className="modal-overlay show"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <motion.div
                className="modal show"
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.8, opacity: 0 }}
                transition={{ duration: 0.3 }}
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "10px",
                  width: "400px",
                  textAlign: "center",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                }}
              >
                <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                  Message Sent!
                </h2>
                <p>Thank you for contacting us. We will get back to you shortly.</p>
                <button className="vc rg lk gh ml il hi gi _l"
                  onClick={() => setShowSuccessModal(false)}
                 
                >
                  Close
                </button>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
          {/* 🔹 Modal */}
                {showModal && (
                  <div
                    className={`modal-overlay ${animate ? "show" : ""}`}
                    onClick={(e) => {
                      if (e.target.classList.contains("modal-overlay")) {
                        closeModal();
                      }
                    }}
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "rgba(0, 0, 0, 0.5)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 1000,
                      opacity: animate ? 1 : 0,
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <motion.div
                      className="modal-box"
                      initial={{ scale: 0.8, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      exit={{ scale: 0.8, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      style={{
                        position: "relative",
                        background: "#fff",
                        padding: "30px",
                        borderRadius: "10px",
                        textAlign: "center",
                        boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                      }}
                    >
                      {/* Close button */}
                      <button
                        onClick={closeModal}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "15px",
                          background: "transparent",
                          border: "none",
                          fontSize: "22px",
                          cursor: "pointer",
                          color: "#333",
                        }}
                      >
                        ×
                      </button>
        
                      <h2 className="fk tj kk wm bb">
                       Contact Now
                      </h2>
                   <form onSubmit={(e) => handleContactSubmit(e)}>
  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <input
        type="text"
        name="fullname"
        id="fullname"
        placeholder="Full name"
        value={contactForm.fullname}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <input
        type="text"
        name="company"
        id="company"
         placeholder="Company name"
        value={contactForm.company}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <input
        type="text"
        name="website"
        id="website"
          placeholder="Website"
        value={contactForm.website}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <input
        type="email"
        name="email"
         placeholder="Email address"
        id="email"
        value={contactForm.email}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
     <input
  type="text"
  name="phone"
  id="phone"
    placeholder="Phone number"
  value={contactForm.phone}
  onChange={(e) => {
    // Allow only digits
    const value = e.target.value.replace(/\D/g, "");
    setContactForm((prev) => ({ ...prev, phone: value }));
  }}
  maxLength={10} // optional: limit to 10 digits
  className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
/>

    </div>
  </div>

  <div className="fb">
    <textarea
      placeholder="Message"
      rows="3"
      name="message"
      id="message"
      value={contactForm.message}
      onChange={handleContactChange}
      className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
    ></textarea>
  </div>

  <div className="tc xf">
      <button
  type="submit"
  className="vc rg lk gh ml il hi gi _l"
  disabled={loading}
>
  {loading ? "Please wait..." : " Send Message"}
</button>

  </div>
</form>
                    </motion.div>
                  </div>
                )}
<section className="hero-section herovv1">
      {/*<video className="hero-video" 
       preload="metadata" loading="lazy" src="/images/bg1set.mp4" autoPlay muted loop playsInline />*/}

      <div className="hero-overlay" />

      <div className="hero-content">
        <div className="hero-inner">
      <motion.section
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
  transition={{
    duration: 1.8,
    ease: "easeOut",
    type: "spring",
    stiffness: 40,
    damping: 20,
  }}
>
          <h1 className="fk vj zp or wcol wm wb">
            
            Global B2B Demand Generation Agency
            <br/>   
          </h1>
          </motion.section>
           <motion.section
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
  transition={{
    duration: 1.8,
    ease: "easeOut",
    type: "spring",
    stiffness: 40,
    damping: 20,
  }}
>
          <h4 className="subhdcss"> Your Strategic Partner in Intelligent, Scalable Marketing Solutions</h4><br/>
             <button
  type="button"
  className="ek jk lk gh gi hi rg ml il vc _d _l"
  onClick={() => {
    window.open(
      "https://42mys2.share-na2.hsforms.com/2ng5j0_QYQzO9GxLl0bsguw",
      "_blank",
      "noopener,noreferrer"
    );
  }}
>
  Contact Today
</button>
     
      </motion.section>

   
      
        </div>
      </div>
    </section>
     {/* <section className="i pg qh rm qi relative">
 <div className="animate_top bb ze rj ki xn vq">
    <motion.section
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
  transition={{
    duration: 1.8,
    ease: "easeOut",
    type: "spring",
    stiffness: 40,
    damping: 20,
  }}
>
        
    

</motion.section>
        </div>
     </section> */}

     
     {/* <section
    className="gj hj i pg"
    style={{
      marginTop: "80px",
      backgroundImage: "url('images/11op.webp')",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      height:"650px"
    }}
  >
    <div className="bb ze ki xn 2xl:ud-px-0">
      <div className="tc _o">
        <div className="animate_left jn/2">
        <motion.section
        initial={{ opacity: 0, x: -90 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.8 }}
      >
          <h1 className="fk vj zp or wcol wm wb">
            
            Global B2B Demand Generation Agency
            <br/>   
          </h1>
          <h4 className="subhdcss"> Your Strategic Partner in Intelligent, Scalable Marketing Solutions</h4>
        
          <div className="tc tf yo zf mb">
            <a
              href="contact"
              className="ek jk lk gh gi hi rg ml il vc _d _l"
            >
              Contact Today
            </a>
          </div>
           </motion.section>
        </div>
      </div>
    </div>
  </section> */}
   {/* <section
    className="gj hj i pg"
    style={{
      backgroundImage: "url('images/12op.webp')",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
        height:"650px"
    }}
  >
    <div className="bb ze ki xn 2xl:ud-px-0">
      <div className="tc _o">
        <div className="animate_left jn/2">
          <h1 className="fk vj  kk wm wb wcol">
          
          </h1>
          <motion.section
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
      >
          <p className="fq">
            Pinakinedge Media is a powerful lead generation and audience engagement partner — blending data science, creative content, advanced technology, human expertise, and multi-channel strategies to deliver real business impact. With our high-performance, intent-driven demand programs, you gain full control of your sales funnel — scaling with precision, engaging the right audience, and achieving measurable results that truly make a difference.
          </p>

          <div className="tc tf yo zf mb">
            <a
              href="contact"
              className="ek jk lk gh gi hi rg ml il vc _d _l"
            >
              Contact Today
            </a>
          </div>
          </motion.section>
        </div>
      </div>
    </div>
  </section> */}

      
<section className="section" id="services" style={{ background: "#F9FAFB" }}>
  <motion.section
    initial={{ opacity: 0, y: 100 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: false, amount: 0.3 }}
    transition={{ duration: 1.2, ease: "easeOut" }}
  >
    <div className="bb ze rj ki xn vq">
      <h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
        WHAT WE OFFER
      </h2>
    </div>

    <div className="funnel-grid">

      <FunnelCard
        icon="/images/tofu.png"
        title="TOFU"
        text={`At the TOFU (Top of Funnel) our focus is on driving awareness and delivering value through education. Content syndication is a powerful way to fuel your funnel with qualified, intent-driven leads. To help you maximize results, we provide a suite of TOFU services, including targeted email marketing, high-quality data services, and strategic content syndication.`}
      />

      <FunnelCard
        icon="/images/mofu.png"
        title="MOFU"
        text={`Our MOFU (Middle of Funnel) solutions are designed to seamlessly bridge awareness into conversion by nurturing engaged prospects with the right content at the right time. We help you build trust and authority in your market, while supporting Account-Based Marketing (ABM) strategies that target and influence the right decision-makers. By delivering better-qualified leads to your sales team, we increase efficiency and maximize ROI from your marketing investments. To accelerate your conversions, we deliver a robust suite of MOFU services — including targeted telemarketing outreach, MQL and HQL generation, BANT-qualified leads, and high-impact webinars — all designed to engage, qualify, and move your prospects closer to purchase.`}
      />

      <FunnelCard
        icon="/images/bofu.png"
        title="BOFU"
        text={`Our BOFU (Bottom of Funnel) solutions empower B2B companies to accelerate conversions and drive measurable revenue through targeted appointment generation and Sales Qualified Lead campaigns. By turning warm prospects into customers, we help you stand out from competitors, strengthen sales enablement with qualified opportunities, and significantly improve lead-to-customer conversion rates — ultimately maximizing your ROI.`}
      />

    </div>
  </motion.section>
</section>


 {/* <div className="slider-container">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`slide ${index === current ? "active" : ""}`}
          style={{ backgroundImage: `url(${slide.image})` }}
        >
          <div className="slider-text">{slide.text}</div>
        </div>
      ))}

      <button className="arrowset leftset" onClick={prevSlide}>
        &#10094;
      </button>
      <button className="arrowset rightset" onClick={nextSlide}>
        &#10095;
      </button>

      <div className="dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={index === current ? "dot active" : "dot"}
            onClick={() => setCurrent(index)}
          ></span>
        ))}
      </div>
    </div> */}


 <section className="hero-section">
      <video
        className="hero-video"
        src="/images/vid3.mp4"
        autoPlay
        muted
        loop
        playsInline
      />

      <div className="hero-overlay" />

      <div className="hero-content">
        <div className="hero-inner">
          <AnimatePresence mode="wait">
            <motion.h1
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className="setslidtext"
            >
              {currentSlide.text}
            </motion.h1>
          </AnimatePresence>
        </div>
      </div>
    </section>
     <section className="i pg ji gp">
      
      <span className="rc h s r vd fd/5 fh rm"></span>
      <img src="/images/shape-08.svg" alt="Shape Bg" className="h q r" />

      <div className="animate_top bb ze rj ki xn vq">
          <motion.section
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
  transition={{
    duration: 1.8,
    ease: "easeOut",
    type: "spring",
    stiffness: 40,
    damping: 20,
  }}
>
        <h2 className="fk vj pr kk wm bb _b">
        Our Demand Generation Mastery
        </h2>
       </motion.section>
      </div>
      {/* Team List */}
      <div className="bb ze i va ki xn jb jo">
      <motion.section
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.3 }}
      className="p-10 bg-gradient-to-r from-blue-50 to-indigo-100 rounded-2xl"
    >
        <div className="wc qf pn tm1 fg">
     
          <motion.div variants={itemVariants("left")}  className="animate_top rj divstyabt">
            
            <div className="c i pg z-1">
              <center>
               <img src="images/marketings.png" className="imgsizeicon" alt="Icon" /></center>
            </div>
            <h4 className="ek yj mk2 gb">Multi-Touch Campaigns</h4>
            <p className="hdse">Build awareness, generate interest, and drive leads with multi-touch campaigns across various platforms.</p>
         </motion.div>

          <motion.div variants={itemVariants("left")}  className="animate_top rj divstyabt">
            <div className="c i pg z-1">
              <center>
               <img src="images/Webinar.png" className="imgsizeicon" alt="Icon" /></center>
            </div>
            <h4 className="ek yj mk2 gb">Webinar & Content Strategies</h4>
            <p className="hdse">Employ webinar and content strategies to capture and nurture leads effectively.</p>
           </motion.div>

       
           <motion.div variants={itemVariants("left")}  className="animate_top rj divstyabt">
            <div className="c i pg z-1">
              <center>
                <img src="images/DataCentric.png" className="imgsizeicon" alt="Icon" /></center>
            </div>
            <h4 className="ek yj mk2 gb">Data-Centric Approach</h4>
            <p className="hdse">Clean, verified, GDPR/CCPA-compliant data ensures precision and accuracy in targeting efforts.</p>
          </motion.div>

            <motion.div variants={itemVariants("left")}   className="animate_top rj divstyabt">
            <div className="c i pg z-1">
              <center>
               <img src="images/Increased.png" className="imgsizeicon" alt="Icon" /></center>
            </div>
            <h4 className="ek yj mk2 gb">Increased Conversion</h4>
            <p className="hdse">Ensuring every campaign is built upon a strong data foundation for higher engagement and conversion likelihood.</p>
          </motion.div>
        </div>  
       
        <br/>
          
        <div className="wc qf pn pn gg cp">
          
              <motion.div variants={itemVariants("left")} className="animate_top rj divstyabt">
            <div className="c i pg z-1">
              <center>
               <img src="images/Digitalmark.png" className="imgsizeicon" alt="Icon" /></center>
            </div>
            <h4 className="ek yj mk2 gb">Account-Based Marketing</h4>
            <p className="hdse">Focus on the accounts that matter most. Our ABM services align sales and marketing to target high-value prospects, deliver personalized campaigns, and drive measurable conversions and growth.</p>
           </motion.div>

         
          <motion.div variants={itemVariants("left")} className="animate_top rj divstyabt">
            <div className="c i pg z-1">
              <center>
             <img src="images/Reliable.png" className="imgsizeicon" alt="Icon" /></center>
            </div>
            <h4 className="ek yj mk2 gb">Reliable Foundation</h4>
            <p className="hdse">Build and maintain a trusted data foundation that ensures every campaign is accurate, targeted, and optimized for performance.</p>
          </motion.div>
          
        </div>
         </motion.section>
      </div>
    </section>
    <section className="i pg qh rm ji hp relative bgblue">
      <img src="images/shape-15.svg" alt="Shape" className="h q p" />

      {/* Stats Section */}
          <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
      >
     <div className="bb ze i va ki xn" ref={ref}>
      <div className="tc uf sn tn xf un gg">
        {/* Stat 1 */}
        <div className="animate_top me/5 ln rj">
          <h2 className="gk vj zp wm hc">
            {inView ? <CountUp end={70} duration={10} suffix="M+" /> : 0}
          </h2>
          <p className="ek bk aq">Audience Data</p>
        </div>

        {/* Stat 2 */}
        <div className="animate_top me/5 ln rj">
          <h2 className="gk vj zp wm hc">
            {inView ? <CountUp end={150} duration={10} suffix="+" /> : 0}
          </h2>
          <p className="ek bk aq">Countries We Reach</p>
        </div>

        {/* Stat 3 */}
        <div className="animate_top me/5 ln rj">
          <h2 className="gk vj zp wm hc">
            {inView ? <CountUp end={98} duration={10} suffix="%" /> : 0}
          </h2>
          <p className="ek bk aq">Client Satisfaction</p>
        </div>

        {/* Stat 4 */}
        <div className="animate_top me/5 ln rj">
          <h2 className="gk vj zp wm hc">
            {inView ? <CountUp end={1} duration={10} suffix="k+" /> : 0}
          </h2>
          <p className="ek bk aq">Project Completed</p>
        </div>

        {/* Stat 5 */}
        <div className="animate_top me/5 ln rj">
          <h2 className="gk vj zp wm hc">
            {inView ? <CountUp end={15} duration={10} suffix="+" /> : 0}
          </h2>
          <p className="ek bk aq">Years Experience</p>
        </div>
      </div>
    </div>
      </motion.section>
    </section>
<br/>
     <section className="i pg qh rm qi relative ii">
 <div className="animate_top bb ze rj ki xn vq">
      <motion.section
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
  transition={{
    duration: 1.8,
    ease: "easeOut",
    type: "spring",
    stiffness: 40,
    damping: 20,
  }}
>
          <h2 className="fk vj pr kk wm on/5 gq/2 bb _b ">
          Our Focus
          </h2>
          <p className="bb on/5 wo/3 jutfy">
            At Pinakinedge Media, we focus on maximizing customer satisfaction through high-quality, intent-driven leads that sales teams actually accept and act on. By ensuring a strong lead acceptance rate and delivering leads at speed, we help clients engage faster, convert more efficiently, and ultimately drive measurable ROI.
          </p>
</motion.section>
        </div>
     </section>

       <section className="i ji ii">
       {/* Bg Shapes */}
      <span className="rc h s r vd fd/5 fh rm"></span>
      <img src="/images/shape-08.svg" alt="Shape Bg" className="h q r" />

      {/* Section Title */}
      <div className="animate_top bb ze rj ki xn vq">
          <motion.section
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
  transition={{
    duration: 1.8,
    ease: "easeOut",
    type: "spring",
    stiffness: 40,
    damping: 20,
  }}
><h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
          Why Choose Us
        </h2></motion.section>
      </div>
      <br/>
      <div className="container">
        {/* Left Side - Image */}
          <motion.section
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
  transition={{
    duration: 1.8,
    ease: "easeOut",
    type: "spring",
    stiffness: 40,
    damping: 20,
  }}
>
        <div className="left">
          <img src="/images/why1.png" alt="Left Side" />
        </div>
</motion.section>
        {/* Right Side - Content */}
        <div className="right">
           <motion.div
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{
          duration: 1.8,
          ease: "easeOut",
          type: "spring",
          stiffness: 40,
          damping: 20,
        }}
      >
          <p className="uo">
          At Pinakinedge Media, we're not just another marketing agency — we're your full-funnel growth partner. We deliver sales-accepted, high-quality leads at speed to maximize ROI, while lowering cost-per-lead, building trust, and strengthening your digital presence.
          <br/> As a global leader in B2B sales and marketing, we provide end-to-end solutions — from demand generation, email, ABM, and content syndication to data intelligence, enrichment, web development, and social media marketing. 
          <br/>Trusted by industry leaders, we combine actionable intelligence, transparency, and proven expertise to drive measurable growth and unlock new revenue opportunities
          </p>
          </motion.div>
        </div>
      </div>

    </section>

      <section>
      {/* Section Title */}
      <div>
        <div className="animate_top bb ze rj ki xn vq">
            <motion.div
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{
          duration: 1.8,
          ease: "easeOut",
          type: "spring",
          stiffness: 40,
          damping: 20,
        }}
      >
          <p  className="fk vj pr kk wm bb _b tej">
           Trusted by leading technology companies for demand generation success
          </p></motion.div>
        </div>
      </div>

       <div className="bb ze ah ch pm hj xp ki xn 2xl:ud-px-49 bc relative">
            <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{
          duration: 2.2,
          ease: "easeInOut",
        }}
      >
            <Slider {...brandSettings} className="wc rf qn zf cp kq xf wf">
              {logos.map((num) => (
                <a href="#!" className="rc animate_top" key={num}>
                  <img
                    className="th wl ml il zl om clilogo"
                    src={`images/clientlogo${num}.png`}
                    alt={`Brand ${num}`}
                  />
                </a>
              ))}
            </Slider></motion.div>
          </div>
    </section>
    <br/>
      <section className="i pg qh rm ji relative bgblue">
                  <motion.section
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
  transition={{
    duration: 1.8,
    ease: "easeOut",
    type: "spring",
    stiffness: 40,
    damping: 20,
  }}
>
             <div className="bb ze i va ki xn">
              <div className="tc uf sn tn xf un gg">
                <h3 className="fk vj wm bb _b">Contact</h3>
              </div>
               <p className="bb on/5 wo/3 hero-sub ">
                 Pinakinedge Media is a powerful lead generation and audience engagement partner - blending data science, creative content, advanced technology, human expertise, and multi-channel strategies to deliver real business impact. With our high-performance, intent-driven demand programs, you gain full control of your sales funnel - scaling with precision, engaging the right audience, and achieving measurable results that truly make a difference.          </p>
          <br/>
              <center>
                <button
  type="button"
    className="centbtn ek jk lk gh gi hi rg ml il vc _d _l"
  onClick={() => {
    setFormType("Home Page");
    openModal(true); // or scroll to form if no modal
  }}
>
  Contact Today
</button>
               </center>
            </div>
              </motion.section>
              
            </section>
            <br/>  
    </main>
      <Footer />
    </div>
  );
}

export default Home;
